import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FooterLinkViewerModels } from '@medsurf/flat-models';
import { FeedbackControlService } from '@medsurf/flat-services';

@Component({
    selector: 'medsurf-footer',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent {
  /**
   * Inputs
   */
  @Input() public align: string;
  @Input() public links: FooterLinkViewerModels.FooterLink[];

  /**
   * Constructor
   *
   * @param feedbackControlService
   */
  public constructor(public feedbackControlService: FeedbackControlService) {
  }

  /**
   * Align Class
   */
  public get alignClass() {
    return 'container-' + this.align;
  }
}
